// @flow

const prepareDefaultColumns = (
  columns: Array<{ size: number, binding: string }>,
  groups: any,
) =>
  columns.map(col => {
    let c;
    if (col.size === 0) {
      const { size, ...rest } = col;

      c = rest;
    } else {
      c = col;
    }

    return c;
  });

export { prepareDefaultColumns };
